<template>
  <div class="rewrite-hub">
    <DomainTabs :tabs="tabs" />
    <div class="rewrite-body">
      <router-view />
    </div>
  </div>
</template>

<script>
import DomainTabs from '../components/shell/DomainTabs.vue'

const TABS = [
  { to: '/create/rewrite/bilibili', label: 'B站洗稿' },
  { to: '/create/rewrite/douyin', label: '抖音洗稿' },
  { to: '/create/rewrite/text', label: '文本洗稿' },
]

export default {
  name: 'RewriteHub',
  components: { DomainTabs },
  setup() {
    return { tabs: TABS }
  },
}
</script>

<style scoped>
.rewrite-hub {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.rewrite-body {
  min-width: 0;
}
</style>
